<template>
 <!-- Start HeaderInside -->
<HeaderInside/>
<!-- End HeaderInside -->
<div class="portada team">
<main id="request-demo" class="content-inside-main">
      <div  class="section-title color-blue">                  
        <div class="container">
          <div class="row">          
            <div class="col-xl-6">
              <div class="team_img">
                   <img src="@/assets/img/GRISELDAGUERRERO.jpeg"  width="500" height="600" alt="" />
             
            </div>
             </div>
             <div class="col-xl-6 team_txt" style="background: rgba(255,255,255,0.7);">
                <br>
                  <h1>{{ $t("member_griselda_title") }}</h1>                  
                  <p style="color:black">{{ $t("member_griselda_text1") }}</p>                 
                 <br>
                  <h4>{{ $t("member_griselda_text2") }}</h4>
                    <p> <a href="tel:+5624181850" target="_blank">(562)418-1850</a> </p>
                  <p style="color:black">{{ $t("member_griselda_text4") }}</p>                                
                  <p>
                    <a href="mailto:helpggs@mytpmschool.com" target="_blank">helpggs@mytpmschool.com</a>
                  </p>
                 
                  <p>
                    <a href="https://ggs.mytpmschool.com" target="_blank">ggs.mytpmschool.com</a>
                  </p>
                
                  <p> <a href="tel:+5623998088" target="_blank">(562)399-8088</a> </p>                   
            </div>
          </div>
        </div>
      </div>
    </main><!-- End #main -->
</div>
    <!-- Start Footer -->
    <Footer/>   
    <!-- End Footer -->
</template>
<script>
import HeaderInside from "@/components/common/HeaderInside.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  props: ["data"],
  data() {
    return {
      scrollPosition: null,
      screenSize: null,
    };
  },
  name: "Home",
  components: {
    HeaderInside,
    Footer,
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    getDimensions() {
      this.screenSize = document.documentElement.clientWidth;
    },
  },
  mounted() {
      this.screenSize = document.documentElement.clientWidth;
    window.addEventListener("scroll", this.updateScroll);
    window.addEventListener("resize", this.getDimensions);
    
  },
};
</script>

<style>
@import "@/assets/css/style.css";
@import "@/assets/vendor/bootstrap/css/bootstrap.min.css";
@import "@/assets/vendor/bootstrap-icons/bootstrap-icons.css";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

</style>